import React, { useEffect } from 'react';
import { Helmet as DefHelmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { usePageData, filterMeta } from './utils';

const Helmet = () => {
  const { i18n } = useTranslation();
  const { title, description, url, date, withoutIndexing } = usePageData();

  useEffect(() => {
    filterMeta.forEach((name) => {
      const selectors = document.querySelectorAll(name);

      selectors.forEach((elem) => {
        const fromHelmet = elem.getAttribute('data-react-helmet');

        if (!fromHelmet && selectors.length === 2) elem.remove();
      });
    });
  }, []);

  return (
    <DefHelmet titleTemplate="Alleye | %s">
      <html lang={i18n.language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={date ? 'article' : 'website'} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {date && <meta property="article:author" content="Oculocare medical" />}
      {date && <meta property="article:published_time" content={date} />}
      {date && <meta property="article:modified_time" content={date} />}
      {date && <meta property="article:section" content="Technology" />}
      {withoutIndexing ? <meta name="robots" content="none" /> : <meta name="robots" content="follow,index" />}
      <link rel="canonical" href={url} />
    </DefHelmet>
  );
};

export default Helmet;
